"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _default = {
    id: '8wfap',
    rewards: [
        {
            id: '8-weeks-free-all-products',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                if (!productId) return false;
                return true;
            }
        }
    ]
};
